<template>
  <v-container class="about">
    <v-row>
      <v-col align="center">
        <v-row>
          <v-col cols="12">
            <h1>{{ $t('common.support')}}</h1>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-img
          src="../assets/toa-heftiba-6bKpHAun4d8-unsplash.jpg"
          lazy-src="https://picsum.photos/id/11/10/6"
          height="200px"
        >
        </v-img>
      </v-col>
    </v-row>
<!--    <v-row>-->
<!--      <v-col align="center">-->
<!--        <p class="text-center">Please find below some easy to use video tutorials which will help you quickly become an-->
<!--          expert at using Navigate.</p>-->
<!--        <v-card class="mx-auto" max-width="800px" height="400px">-->
<!--          <iframe width="100%" height="100%" src="https://www.youtube.com/embed/YbJOTdZBX1g?controls=0&modestbranding=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
<!--        </v-card>-->
<!--      </v-col>-->
<!--    </v-row>-->
    <v-row>
      <v-col align="center"
             justify="center">
        <h1>{{ $t('common.faqs')}}</h1>
        <p>
          {{ data.body[0].primary.text[0].text }}
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-expansion-panels popout>
          <v-expansion-panel
            v-for="(item,i) in data.body[0].items"
            :key="i"
          >
              <v-expansion-panel-header
                class="font-weight-bold">
               {{ ++i }}. {{ item.question[0].text }}
              </v-expansion-panel-header>
            <v-expansion-panel-content>
              <p>{{ item.answer[0].text }}</p>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <v-row>
      <v-col align="center"
             justify="center">
        <h1>{{ $t('common.support')}}</h1>
        <p>{{ $t('support.cta')}}</p>
        <v-btn color="indigo" dark id="open_intercom_chat">{{ $t('common.contact-support')}}</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Support',
  data: () => ({
    data: null,
    tab: null,
    text: 'hello world',
  }),
  methods: {
    getContent() {
      this.$prismic.client.getSingle('support-page', { lang: this.$i18n.locale })
        .then((document) => {
          this.data = document.data;
        });
    },
  },
  created() {
    this.getContent();
  },
};
</script>

<style scoped>

</style>
